import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { API_BASE_URL } from "../../config/config";
import SalesTrendHeader from "../../Pages/SalesTrendHeader";
import StockistFilter from "./component/stockistFilter";
import StockistDataComp from "./component/StockistDataComp";
import StockistTable from "./component/StockistTable";
import React from "react";
import { useTokenFromQuery, useFetchUserDetails, getUserIdFromToken ,useResetRefreshTime } from "../../utils/dashboardUtils.js";


interface DecodedToken {
  name: string;
  preferred_username: string;
}

const StockistDashboard: React.FC = () => {
  const [refreshTime, setRefreshTime] = useState<string | null>(null);
  const [userLocation, setUserLocation] = useState<string | null>(null);
  const [headerUsername, setHeaderUsername] = useState<string | null>(null);
  useTokenFromQuery("/app/stockist_dashboard");
  useFetchUserDetails(setUserLocation, setHeaderUsername, setRefreshTime, API_BASE_URL , "stockist_dashboard");
  useResetRefreshTime(setRefreshTime);
  const user_id = getUserIdFromToken();

  return (
    <div className="sales-trend-dashboard">
      <div className="dashboard-container">
        <SalesTrendHeader
          title="Stockist Wise Sales (Trade Only)"
          userName={headerUsername }
          location={userLocation }
          refreshTime={refreshTime}
        />
        <StockistFilter user_id={user_id} />
        <StockistDataComp />
        <StockistTable />
      </div>
    </div>
  );
};

export default StockistDashboard;
